import { AdvertiserType } from '@sbt-web/network/types';

const isPro = (advertiserType) => advertiserType === AdvertiserType.Pro;

export { isPro };
//# sourceMappingURL=shop.js.map
